export default __webpack_public_path__ + "static/media/company.f58d6846.jpg";